import React, { useEffect, useState } from "react";
import Sidebar from "../../partials/aside/Sidebar";
import { Link, useParams, useHistory } from "react-router-dom";
import httpService from "../../../services/httpServices/httpServices";
import helpersNumbers from "../../../helpers/numbers";
import helperSpinner from "../../../helpers/spinner";
import validationsAddPosition from "../../../validtions/forms/position/add";
import sizesBanner from "../advertise/banner/sizes-banner";

export default function AddPositionIndependent() {
  const params = useParams();
  const [message, setMessage] = useState();
  const [count, setCount] = useState(0);
  const [basePrice, setBasePrice] = useState(10000);
  const [alternativePrice, setAlternativePrice] = useState(2000);
  const [price, setPrice] = useState(0);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [imageSrc, setImageSrc] = useState();
  const history = useHistory();
  const sitePublisherID = params.id;
  const [sitePublisher, setSitePublisher] = useState({});
  const [maxPriority, setMaxPriority] = useState();

  let messageTag;
  if (message) {
    messageTag = (
      <div className={`${message.type_class}`}>
        <i className={`${message.class_icon} pl-2`}></i>
        <span>{message.text}</span>
      </div>
    );
  }

  useEffect(() => {
    getSitePublisher(sitePublisherID);
  }, []);

  useEffect(() => {
    if (!sitePublisherID) {
      return;
    }
    getImage();
  }, [sitePublisherID]);

  const getImage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const image = await sendRequestGetImage(sitePublisherID);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!image) {
      return;
    }

    setImageSrc(image.url);
  };

  const sendRequestGetImage = async (sitePublisherID) => {
    const headersRequest = getHeaderForRequest();
    let image;
    try {
      image = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/image-independent-positions/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return image.data.data;
  };

  useEffect(() => {
    changePrice();
  }, [sitePublisher]);

  useEffect(() => {
    changePrice();
  }, [count]);

  useEffect(() => {
    changePrice();
  }, [basePrice]);

  useEffect(() => {
    if (!sitePublisherID) {
      return;
    }
    getMaxPriorityPositionOnPage();
  }, [basePrice]);

  const getMaxPriorityPositionOnPage = async () => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const maxPriority = await sendRequestGetMaxPriorityPositionOnSitePublisher(
      sitePublisherID
    );
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    if (!maxPriority) {
      return;
    }
    setMaxPriority(maxPriority);
  };

  const sendRequestGetMaxPriorityPositionOnSitePublisher = async (
    sitePublisherID
  ) => {
    const headersRequest = getHeaderForRequest();
    let result;
    try {
      result = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/" +
          sitePublisherID +
          "/get-max-priority-position-independent",
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }
    return result.data.data;
  };

  const changePrice = () => {
    if (!(count > 0)) {
      setPrice(0);
      return;
    }
    setPrice(Math.floor(basePrice / count));
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  const getSitePublisher = async (sitePublisherID) => {
    const sitePublisher = await sendRequestGetSitePublisher(sitePublisherID);
    if (!sitePublisher) {
      return;
    }

    setSitePublisher(sitePublisher);
  };

  const sendRequestGetSitePublisher = async (sitePublisherID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    let resultRequest;
    try {
      resultRequest = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/site-publishers/" +
          sitePublisherID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return resultRequest.data.data;
  };

  const sendForm = async (e) => {
    e.preventDefault();
    const dataForm = getDataForm();
    if (validationsAddPosition(dataForm) != true) {
      setMessage({
        type_class: "alert alert-danger",
        text: validationsAddPosition(dataForm),
        class_icon: "fa fa-exclamation-triangle",
      });
      scrollForSeeMessage();
      return;
    }
    dataForm.publisher_id = sitePublisherID;
    await addPosition(dataForm);
  };

  const scrollForSeeMessage = () => {
    const element = document.querySelector(".card-body");
    element.scrollIntoView();
  };

  const inputAlternativePriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setAlternativePrice(parseInt(number));
  };

  const getDataForm = () => {
    return {
      base_price: basePrice + "",
      price: price + "",
      alternative_price: alternativePrice + "",
      count: document.querySelector("#count").value,
      height: document.querySelector("#height").value,
      width: document.querySelector("#width").value,
      site_publisher_id: sitePublisherID,
      active: +document.querySelector("#active").checked,
      priority: document.querySelector("#priority").value,
      allow_alternative: document.querySelector("#active-advertise-alternative")
        .checked,
    };
  };

  const addPosition = async (data) => {
    if (await sendRequestAddPosition(data)) {
      history.push("/manage/position/all-independent/" + sitePublisherID);
    }
  };

  const sendRequestAddPosition = async (data) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const headersRequest = getHeaderForRequest();
    try {
      await httpService.postRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/position/manage/independent-positions",
        data,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
      return false;
    }
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    return true;
  };

  const inputPriceChangeHandler = (e) => {
    let number = e.target.value;
    number = helpersNumbers.toEnglishNumber(number.replaceAll(",", ""));
    if (number == "") {
      number = 0;
    }
    setBasePrice(parseInt(number));
  };

  const inputPriceBeforeInputHandler = (e) => {
    const regexLetter = new RegExp("^[0-9\b]+$");
    if (!regexLetter.test(e.data)) {
      e.preventDefault();
      return;
    }
  };

  const generateButtonsSize = () => {
    return sizesBanner.map((sizeBanner) => {
      return (
        <div className="col-3 py-2">
          <div
            onClick={(e) => {
              e.preventDefault();
              setWidth(sizeBanner.width);
              setHeight(sizeBanner.height);
            }}
            className="btn btn-primary letter-spacing-finance-number p-2"
          >
            {helpersNumbers.toPersianNum(sizeBanner.height)}
            {"    "}-{"    "}
            {helpersNumbers.toPersianNum(sizeBanner.width)}
          </div>
        </div>
      );
    });
  };

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  <span> اضافه کردن جایگاه مستقل به سایت </span>
                  <a
                    className="pr-2 text-info"
                    target="_blank"
                    href={sitePublisher?.url}
                  >
                    {sitePublisher?.url?.replace("http://", "")}
                  </a>
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {messageTag}
              <div className="text-left">
                <Link
                  to={`/manage/position/all-independent/${sitePublisherID}`}
                >
                  <div className="btn btn-primary">
                    <span>
                      <span className="text-white">بازگشت</span>
                    </span>
                    <span className="pr-2">
                      <i className="fas fa-arrow-left" aria-hidden="true"></i>
                    </span>
                  </div>
                </Link>
              </div>
              <div className="pt-2">
                <div className="alert alert-info">
                  <div>
                    <span className="pl-2">
                      <i className="fa fa-info"></i>
                    </span>
                    <span>
                      مبلغ نمایش یک تبلیغ در یک شبانه روز = مبلغ پایه / تعداد
                      تعداد بنر در جایگاه
                    </span>
                  </div>
                  <div>
                    <span>تمامی مبالغ به تومان است</span>
                  </div>
                </div>
              </div>
              <form className="w-50" onSubmit={sendForm}>
                <div className="form-group">
                  <label>تعداد بنر در جایگاه</label>
                  <input
                    tabIndex="1"
                    dir="ltr"
                    type="number"
                    id="count"
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      e.preventDefault();
                      setCount(parseInt(e.target.value));
                    }}
                    className="form-control"
                    required
                  />
                </div>
                <div className="form-group">
                  <label>مبلغ پایه </label>
                  <input
                    tabIndex="2"
                    type="text"
                    id="price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(basePrice)
                    )}
                    onChange={inputPriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>مبلغ نمایش یک تبلیغ در یک شبانه روز :‌ </label>
                  <span
                    className="letter-spacing-finance-number"
                    style={{ fontSize: "22px" }}
                  >
                    {helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(price)
                    )}
                  </span>
                </div>

                <div className="form-group">
                  <label className="pl-2">فعال بودن تبلیغ جایگزین</label>
                  <span>
                    <label className="adl-switch">
                      <input
                        type="checkbox"
                        id="active-advertise-alternative"
                      />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <label>مبلغ بنر جایگزین</label>
                  <input
                    type="text"
                    id="alternative-price"
                    className="form-control number-finance"
                    value={helpersNumbers.toPersianNum(
                      helpersNumbers.toFormatFinanceNumber(alternativePrice)
                    )}
                    onChange={inputAlternativePriceChangeHandler}
                    onBeforeInput={inputPriceBeforeInputHandler}
                    dir="ltr"
                    required
                  />
                </div>

                <div className="form-group">
                  <div className="d-flex justify-content-between">
                    <div>
                      <label>ارتفاع</label>
                      <input
                        tabIndex="3"
                        dir="ltr"
                        type="number"
                        id="height"
                        defaultValue={height || ""}
                        className="form-control"
                        required
                      />
                    </div>
                    <div>
                      <label>عرض</label>
                      <input
                        tabIndex="2"
                        dir="ltr"
                        type="number"
                        id="width"
                        defaultValue={width || ""}
                        className="form-control"
                        required
                      />
                    </div>
                  </div>
                  <div className="pt-3">
                    <label>اندازه بنرهای تبلیغاتی</label>
                    <div>
                      <div className="row">{generateButtonsSize()}</div>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label>
                    اولویت برای گروه نمایش دهنده خودکار (
                    {maxPriority && (
                      <span>
                        بالاترین اولویت در این سایت =
                        {helpersNumbers.toPersianNum(maxPriority)}
                      </span>
                    )}
                    )
                  </label>
                  <input
                    tabIndex="5"
                    type="number"
                    onWheel={(e) => e.target.blur()}
                    id="priority"
                    className="form-control"
                    required
                  />
                </div>

                <div className="form-group">
                  <span className="pl-2">
                    <label>فعال</label>
                  </span>
                  <span>
                    <label className="adl-switch">
                      <input type="checkbox" id="active" />
                      <span className="adl-slider round"></span>
                    </label>
                  </span>
                </div>

                <div className="form-group">
                  <button className="btn btn-primary">اضافه کردن</button>
                </div>
              </form>
              <div className="pt-4 ">
                {imageSrc == undefined ? (
                  <></>
                ) : (
                  <div className="border border-dark">
                    <a href={imageSrc} target="_blank">
                      <img class="img-fluid" src={imageSrc} />
                    </a>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
